import CityPageTemplate from "../city-template/CityPageTemplate";
import { ashburnVaConfig } from "./data";

export default function AshburnVaPage() {
  return <CityPageTemplate config={ashburnVaConfig} />;
}